document.addEventListener("DOMContentLoaded", function() {
  const videoLinks = document.querySelectorAll(".video-link"),
      closeButtons = document.querySelectorAll(".closePopupProdVideo"),
      overlay = document.querySelector(".popup-overlay"),
      videoPopups = document.querySelectorAll(".video-popup");
  const videoParent = overlay.parentElement;
  videoLinks.forEach((link, index) => {
    link.addEventListener("click", function(e) {
      if (e.preventDefault(), openPopup(index + 1), videoUrls[index]) {
        const video = document.querySelector("#video-" + (index + 1)); 
        videoSources = video.querySelectorAll("source");
        videoSources[0].src = videoUrls[index].source1; 
        video.load(); 
        video.play();
      }
    });
  }); 
  closeButtons.forEach(button => {
    button.addEventListener("click", function() {
      closePopup();
    }); 
  });
  overlay.addEventListener("click", function() {
      closePopup();
    });

  function openPopup(index) {
    const popup = document.querySelector(".product-video-pop-" + index);
    if (popup){    
      document.body.appendChild(popup);
      document.body.appendChild(overlay);
      popup.classList.remove("hidden-video");     
      overlay.classList.remove("hidden-video");     
      document.body.classList.add("body-no-scroll");
    }
  }

  function closePopup() {
    console.log(videoParent);
    videoPopups.forEach(popup => {
      const video = popup.querySelector("video");
      if (video) {
        video.pause();
      }
      popup.classList.add("hidden-video"); 
      document.body.classList.remove("body-no-scroll");
      videoParent.appendChild(popup);
    }); 
    overlay.classList.add("hidden-video");
    videoParent.appendChild(overlay);
  }
});